import styled from "styled-components";
import { colors } from "../common/element/elements.js";

export const Styles = styled.div`
    .icon-box-area {
        margin-top: 50px;
        padding-bottom: 80px;

        .icon-box-heading {
            display: flex !important;
            justify-content: center !important;
            align-items: center !important;
        }

        .icon-box-heading h3 {
            color: ${colors.black1};
            font-weight   : 600;
            text-transform: uppercase;
            margin-bottom : 37px;

            span {
                color: ${colors.green};
            }

            @media(max-width: 575px) {
                margin-bottom: 15px;
                font-size: 20px;
            }
        }

        .full-icon-box {
            position: relative;
            margin-top: 50px;

            .icon-box {
                position: relative;
                margin-bottom: 50px;
                left: 0;
                width: 100%;
                background: #fff;
                // padding: 35px 20px 20px;
                z-index: 9;
                box-shadow: 0 12px 25px rgba(0, 0, 0, 0.07);
                border-radius: 10px;

                .box-logo {
                    text-align: center;
                    margin-bottom: 10px;

                    img {
                        width: 100% !important; 
                        border-radius: 10px 10px 0 0;
                    }
                    @media (max-width: 992px) and (min-width: 512px){
                        img {
                        width: 100% !important; 
                        border-radius: 10px 10px 0 0;
                        }
                    }
                }

                .box-title {
                    margin-top: 15px; /* Adjust the margin as per your preference */

                    h6 {
                        color: ${colors.black1};
                        // text-transform: uppercase;
                        font-weight: 600;
                        margin-bottom: 6px;
                        padding-bottom: 6px;
                        text-align: center;
                        margin-left: 28px;
                        margin-right: 28px;
                        font-family: 'Roboto Slab', sans-serif;
                    }                    

                    p {
                        font-size: 12px;
                        color: ${colors.text3};
                    }
                }
                @media (max-width: 992px) and (min-width: 512px){
                    .box-title {
                        
                        h6 {
                            margin-bottom: 6px;
                            padding-bottom: 15px;
                        }     
                    }
                }
            }
        }
        @media (min-width: 992px) {
            .full-icon-box {
                .icon-box {
                    height: 300px !important;
                }
            }
           
        }

        @media (max-width: 992px) and (min-width: 512px){
            .full-icon-box {
                    position: relative;
                    text-align: center;
                .icon-box {
                    text-align: center;
                    height: 300px !important;
                    width: 100% !important;
                }
            }
        }
       
    }
`;
